export default "__VITE_ASSET__Bnq5gQxd__"